import SiteLayout from "@/components/SiteLayout";
import PageMeta from "@/components/PageMeta";
import ContactSection from "@/components/sections/ContactSection";

export default function Contact() {
  return (
    <SiteLayout>
      <PageMeta
        title="Contact — Carlton Elleker Chase"
        description="Tell us a little about your matter and we will direct your enquiry to the right partner."
        path="/contact"
      />
      <ContactSection
        compact
        intro="Tell us a little about your matter and we will direct your enquiry to the right partner. For urgent matters, please call the office directly."
      />

      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28 hairline-top" data-testid="careers-section">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-3">
            <p className="overline text-graphite/55">Join us</p>
          </div>
          <div className="md:col-span-9 max-w-3xl">
            <p className="text-lg md:text-xl text-graphite/85 leading-relaxed">
              We are looking for innovative, driven self starters to come and join our growing team.
              Please feel free to contact us in confidence by email to:
            </p>
            <a
              href="mailto:work@ceclegal.co.uk"
              className="mt-6 inline-block text-2xl md:text-3xl font-medium text-[#1E3668] hover:text-[#021D6F] transition-colors break-all"
              data-testid="careers-email"
            >
              work@ceclegal.co.uk
            </a>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
